<template>
  <bg-modal
    :value="value"
    :title="title"
    data-testid="publish-confirmation-modal"
    desktop-size="lg"
    button-main-text="Publish"
    button-second-text="Batal"
    :button-main-props="{ loading }"
    :body-scroll="false"
    @input="$emit('input', $event)"
    @close="$emit('input', false)"
    @click-second-action="$emit('input', false)"
    @click-main-action="$emit('confirm')"
  >
    <bg-alert variant="info" :closable="false">
      <bg-text v-if="isStartingToday" size="body-2" data-testid="publish-info">
        Program yang di-publish ke <strong>{{ audienceLabel }}</strong> akan
        menjadi <strong>Aktif</strong> dan tidak dapat diubah menjadi
        <strong>Draft</strong>.
      </bg-text>

      <bg-text v-else size="body-2" data-testid="publish-info">
        Program akan dijadwalkan untuk di-publish ke
        <strong>{{ audienceLabel }}</strong> pada tanggal
        <strong>{{ startDateLabel }}</strong> dan akan menjadi
        <strong>Aktif</strong>.
      </bg-text>
    </bg-alert>

    <bg-text size="body-2" class="bg-u-mt-md bg-u-mb-sm">
      Informasi program ini akan tampil di halaman Dashboard Singgahsini.
      Periksa kembali dan pastikan detail program sudah sesuai:
    </bg-text>

    <owner-program-card
      :name="program.name"
      :description="program.description"
      :banner="program.banner"
      :quota="program.quota"
      :start-date="program.startDate"
      :end-date="program.endDate"
      :buttons="program.buttons"
      :text-fields="program.textFields"
    />
  </bg-modal>
</template>

<script>
import { computed } from '@vue/composition-api';
import { BgModal, BgAlert, BgText } from 'bangul-vue';

import { PROGRAM_TARGET_LABEL } from '@admin_pages/OwnerProgram/constants';

import OwnerProgramCard from '@/components/molecules/OwnerProgramCard';

import { dateFormatterToDisplay, dayjs } from '@/utils/formatter';

export default {
  name: 'PublishConfirmationModal',

  components: {
    BgModal,
    BgAlert,
    BgText,
    OwnerProgramCard,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    program: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const title = computed(() => `Publish Program "${props.program.name}"?`);

    const audienceLabel = computed(
      () => PROGRAM_TARGET_LABEL[props.program.targetType] || ''
    );

    const startDateLabel = computed(() =>
      dateFormatterToDisplay(props.program.startDate, 'DD MMMM YYYY')
    );

    const isStartingToday = computed(() =>
      dayjs(props.program.startDate).isSame(dayjs(), 'day')
    );

    return {
      title,
      audienceLabel,
      startDateLabel,
      isStartingToday,
    };
  },
};
</script>
